import { getObjectUtil } from 'packages/src'

function getReduxSelector (path) {
  return state => getObjectUtil(state, path)
}

export default getReduxSelector
